import { useEffect, useRef } from 'react';

export default function InfiniteScrollObserver({ disabled = false, fetchNextPage, hasNextPage, rootMargin = '200px' }) {
    const loadMoreRef = useRef(null);

    useEffect(() => {
        if (disabled || !hasNextPage || !loadMoreRef.current) return;

        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting) {
                    fetchNextPage && fetchNextPage();
                }
            },
            { rootMargin }
        );

        observer.observe(loadMoreRef.current);

        return () => observer.disconnect();
    }, [disabled, hasNextPage, fetchNextPage]);

    return <div ref={loadMoreRef} />;
}
